import TABLE_CONSTANTS from '../enums/Constants';

/**
 *
 */
function getInitialQuery(presets) {
    return (
        {
            offset: presets && presets.offset ? presets.offset : TABLE_CONSTANTS.OFFSET_STARTING_VALUE, // Starting position
            limit: presets && presets.limit ? presets.limit : TABLE_CONSTANTS.ROWS_NUMBER_PER_PAGE, // Number of rows per page
            orders: presets && presets.orders ? presets.orders : [],
            filters: presets && presets.filters ? presets.filters : []
        }
    );
}

export default getInitialQuery;